/**
 * Aktywuje daterange pickera
 */
$(function () {
    activeDaterangePicker('#created_at', ranges)
    activeDaterangePicker('#date_paid', ranges)
    activeDaterangePicker('#date_payment', ranges)
    activeDaterangePicker('#date_issue', ranges)
})

/**
 * Aktywuje multiselecta
 *
 * @param id
 */
global.activeMultiSelect = function activeMultiSelect(id) {
    $(id).multiSelect()
}

$(function () {
    $('.daterange').daterangepicker({
        "locale": {
            'format': 'DD.MM.YYYY',
            'separator': ' - ',
            'applyLabel': 'Zapisz',
            'cancelLabel': 'Anuluj',
            'fromLabel': 'Od',
            'toLabel': 'Do',
            'customRangeLabel': 'Niestandardowy',
            'weekLabel': 'W',
            'daysOfWeek': [
                'Nd',
                'Pn',
                'Wt',
                'Śr',
                'Cz',
                'Pt',
                'Sb'
            ],
            'monthNames': [
                'Styczeń',
                'Luty',
                'Marzec',
                'Kwiecień',
                'Maj',
                'Czerwiec',
                'Lipiec',
                'Sierpień',
                'Wrzesień',
                'Październik',
                'Listopad',
                'Grudzień'
            ],
            'firstDay': 1
        },
        opens: 'left'
    });
});

/**
 * Kod który służy pomocniczo do obsługi okienka modalnego do dodawania użytkowników do spółek (client)
 */

$('#add-user-to-client-modal').on('shown.bs.modal', function (e) {
    $('#add-user-to-client-client_id').val($('#client_id').val())
})

$('#add-user-to-client-form').on('ajaxify:form_success', function () {
    showAlert(trans['user.user_added_to_client'], 'success')
    $('#add-user-to-client-modal').modal('hide')
    $('#user-table').bootstrapTable('refresh')
})
